import { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import Breadcrumbs from "examples/Breadcrumbs";
import AddForm from "../components/EditForm";
import AttachmentForm from "../components/EditAttachmentForm";
import BugdetForm from "../components/EditBudgetForm";
import validations from "../schemas/validations";
import form from "../schemas/form";
import initialValues from "../schemas/initialValues";
import { RequestService } from "services/RequestService";
import MDSnackbar from "components/MDSnackbar";
import { useNavigate } from "react-router-dom";
// import PmForm from "../components/PmForm";
function getSteps() {
  return ["معلومات المشروع", "الميزانية", "المرفقات"];
}

function getStepContent(stepIndex, formData) {
  switch (stepIndex) {
    case 0:
      return <AddForm formData={formData} />;
    case 1:
      return <BugdetForm formData={formData} />;
    // case 2:
    //   return <PmForm formData={formData} />;
    case 2:
      return <AttachmentForm formData={formData} />;
    default:
      return null;
  }
}

function EditProject() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleBack = () => setActiveStep(activeStep - 1);
  const [initialValuesState, setinitialValuesState] = useState({ ...initialValues });
 // read id from url
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const formatDate = (dateString) => {
    // Convert date string to Date object and then format it as yyyy-MM-dd
    const date = new Date(dateString);
    return date.toISOString().slice(0, 10);
  };

  const submitForm = async (values, actions) => {
    await sleep(1000);

    await RequestService.putFormData("Project", values)
      .then(async (result) => {
        setMessage(result.data.message);
        if (result.status === 200) {
          setMessage(result.data.message);
          setShow(!show);
          await sleep(1000);
          navigate("/pages/projects/viewprojects");
        } else {
          setMessage(result.data.message);
          setError(!error);
        }
      })
      .catch((errorResponse) => {
        setMessage(errorResponse.response.data.message);
        setError((prevError) => !prevError);
      });

    actions.setSubmitting(false);
    actions.resetForm();
    setActiveStep(0);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const fetchData = async () => {
      await RequestService.get(`Project/${id}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;
            data.startedDate = formatDate(data.startedDate);
            data.endedDate = formatDate(data.endedDate);
            setinitialValuesState(data);
          }
        })
        .catch((errorResponse) => {
          setMessage(errorResponse.response.data.Message);
        });
    };
    fetchData();
  }, []);

  const handleSubmit = (values, actions) => {
    if (isLastStep) {
      submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <Breadcrumbs
        icon="home"
        title={"Edit Project"}
        route={[
          { path: "pages/projects/viewprojects", display: "المشاريع" },
          { path: `projectinfo?id=${id}`, display: "المشروع" },
          { path: "pages/projects/projectManagers", display: "مدراء المشروع" },
        ]}
        light={false}
      />
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تمت العملية بنجاح"
        content={message}
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />
      <MDSnackbar
        color="error"
        icon="notifications"
        title="فشلت العملية"
        content={message}
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={12} lg={8}>
            <Formik
              initialValues={initialValuesState}
              validationSchema={currentValidation}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, errors, touched, isSubmitting, setValues, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox mx={2} mt={-3}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </MDBox>
                    <MDBox p={3}>
                      <MDBox>
                        {getStepContent(activeStep, {
                          values,
                          touched,
                          formField,
                          errors,
                          setValues,
                          setFieldValue,
                        })}
                        <MDBox mt={2} width="100%" display="flex" justifyContent="space-between">
                          {activeStep === 0 ? (
                            <MDBox />
                          ) : (
                            <MDButton variant="gradient" color="light" onClick={handleBack}>
                              السابق
                            </MDButton>
                          )}
                          <MDButton
                            disabled={isSubmitting}
                            type="submit"
                            variant="gradient"
                            color="dark"
                          >
                            {isLastStep ? "إرسال" : "التالي"}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditProject;
